<template>
  <v-dialog v-model="openModal" persistent width="auto" @input="$emit('input', $event)">
    <div class="modal-card" style="margin-left: unset">
      <header class="modal-card-head">
        <p :class="isMobile ? 'mobile-modal-card-title' : 'modal-card-title'">
          投稿処理中のため操作できませんでした
        </p>
      </header>
      <section class="modal-card-body">
        <p>
          他のユーザーによる操作などで対象の投稿が処理中のため、今回の操作は受け付けられませんでした。履歴画面を再読み込みして最新の状態をご確認ください。
        </p>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click.prevent="$emit('reload-post-histories')">
          再読み込み
        </button>
      </footer>
    </div>
  </v-dialog>
</template>
<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    openReloadConfirm: { type: Boolean, required: true, default: false },
    isMobile: { type: Boolean, default: false },
  },
  emits: ["input", "reload-post-histories"],
  computed: {
    openModal: {
      get() {
        return this.openReloadConfirm;
      },
      set(value: boolean) {
        this.$emit("input", value);
      },
    },
  },
});
</script>
<style lang="scss" scoped>
.modal-card-title {
  margin: 0;
}
.mobile-modal-card-title {
  @extend .modal-card-title;
  font-size: 1.1rem;
  font-weight: bold;
}
.date-highlight {
  color: red;
  font-size: 1.5rem;
}
</style>
